import type { User, LoginRequest, RegisterRequest, LoginResponse } from '~/types/api'

export const useAuth = () => {
  const user = useState<User | null>('auth.user', () => null)
  const token = useCookie<string | null>('auth_token', {
    httpOnly: true,
    secure: true,
    sameSite: 'strict',
  })

  const isAuthenticated = computed(() => !!token.value || !!user.value)
  // 登录
  const login = async (credentials: LoginRequest) => {
    const res = await createApiCall<LoginResponse>(`/login`, {
      method: 'POST',
      body: credentials,
    })

    user.value = res.user

    return res
  }

  // 注册
  const register = async (userData: RegisterRequest) => {
    const res = await createApiCall<LoginResponse>(`/register`, {
      method: 'POST',
      body: userData,
    })

    // 注册成功后自动登录
    await login({
      phone: userData.phone,
      password: userData.password,
    })

    return res
  }

  // 获取用户信息
  const fetchProfile = async () => {
    try {
      const res = await createApiCall<User>(`/profile`, {
        method: 'GET',
      })

      user.value = res
      return res
    }
    catch (error) {
      // Token可能已过期，清除认证状态
      console.log('fetchProfile error', error)
    }
  }

  // 登出
  const logout = () => {
    token.value = null
    user.value = null

    // 重定向到登录页
    if (import.meta.client) {
      navigateTo('/login')
    }
  }

  // 初始化认证状态（SSR友好）
  const initAuth = async () => {
    if (!user.value) {
      try {
        await fetchProfile()
      }
      catch {
        // 静默处理错误，token可能已过期
      }
    }
  }

  return {
    user: readonly(user),
    token,
    isAuthenticated,
    login,
    register,
    logout,
    fetchProfile,
    initAuth,
  }
}
